import {Injectable} from '@angular/core';
import {Feature} from '@catcore/services/feature/feature';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {extractDataFromProperty} from '@catcore/utils';
import {Resource} from '@catfeatures/types';
import {FeatureEvidFunction, FeatureEvidFunctionCreateInfo} from '@catmodules/models/feature-evid-functions/types';
import {Restangular} from 'ngx-restangular';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import {isNullOrUndefined} from 'util';

const singleton = () => {
  return (target) => {
    target.currentSource = new BehaviorSubject(null);
    target.current = null;
    target.current$ = target.currentSource.asObservable();

    target.loadAsCurrent = (id: string) => {
      this.getOne(id).subscribe((feature: any) => {
        this.currentSource.next(feature);
      });
    };

    target.refreshCurrent = () => {
      if (this.current) {
        this.loadAsCurrent(this.current.id);
      }
    };
  };
};

@Injectable()
@singleton()
export class FeatureEvidFunctionsService extends RestHttpService<any> {

  constructor(service: Restangular) {
    super('feature-evid-functions', service);
  }

  create(item: FeatureEvidFunctionCreateInfo): Observable<any> {
    const createInfos = {
      featureType: item.feature._links.self.href,
      model: item.evidFunction._links.self.href,
    };

    return this.queryAll()
      .post(createInfos)
      .map((createdFeature) => {
        // this.store.dispatch({
        //     type: storeActions.CORE_FEATURE_CREATED,
        //     payload: createdFeature,
        //   },
        // );
        return createdFeature;
      });
  }

  extractLinkedPortsFor(resourceModel: FeatureEvidFunction): any[] {
    const lookupKey = 'linked_ports';
    return extractDataFromProperty(resourceModel as Resource, lookupKey);
  }

  extractEvidVidsFor(resourceModel: FeatureEvidFunction): any[] {
    const lookupKey = 'evid_vid_types';
    return extractDataFromProperty(resourceModel as Resource, lookupKey);
  }

  extractLinkedUnitsFor(resourceModel: FeatureEvidFunction) {
    const lookupKey = 'linked_units';
    return extractDataFromProperty(resourceModel as Resource, lookupKey);
  }

  extractLinkedVidsFor(resourceModel: FeatureEvidFunction) {
    const lookupKey = 'linked_vids';
    return extractDataFromProperty(resourceModel as Resource, lookupKey);
  }

  extractLinkedServicesFor(resourceModel: FeatureEvidFunction) {
    const lookupKey = 'linked_services';
    return extractDataFromProperty(resourceModel as Resource, lookupKey);
  }

  /**
   * Updates the feature evid function from the underlying model.
   * @param id
   */
  updateFromModel(id: any) {
    return this.getRawSubresource(id, 'update');
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/feature-evid-functions/services/feature-evid-functions.service.ts